import { Component, ElementRef, Input, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { UserSearchTermsService } from 'src/app/shared/services/user-search-terms.service';
import { IKeyValuePair } from '../../services/rest/base.service';
import { ModalDialogComponent } from '../modal-dialog/modal-dialog.component';
import { first } from 'rxjs/operators';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'app-search-terms-favorizer',
  templateUrl: './search-terms-favorizer.component.html',
  styleUrls: ['./search-terms-favorizer.component.scss']
})
export class SearchTermsFavorizerComponent implements OnInit {

  @ViewChild('wrapper') wrapper: ElementRef;
  @ViewChild('modalBodyPrompt') modalBodyPrompt: ElementRef;
  @ViewChild('searchTermsLabelPrompt') searchTermsLabelPrompt: ModalDialogComponent;

  @Input() entries: IKeyValuePair<number | string, string>[] = [];

  selectedKey: string;
  shouldExpand = false;
  favoriteLabel = '';
  favoriteSearchTerms: Array<{ key: string, label: string, record: Object }> = null;
  newFormData: Subscription;

  @Input() targetForm = null;
  @Input() searchForm: FormData = null;
  
  constructor(private ustService: UserSearchTermsService, private cdr: ChangeDetectorRef) { }

  ngOnInit() {
    document.addEventListener('click', this.globalUIEventHandler.bind(this));
    document.addEventListener('focus', this.globalUIEventHandler.bind(this));

    this.ustService.getAllStoredTerms().pipe(first()) .subscribe(payload => {
      // ! BUG: Workaround for unexplained different return types
      if (payload.status && payload.body) { payload = payload.body; }

      this.favoriteSearchTerms = payload.Settings.map(favRecord => {
        const label = favRecord.Key.replace('RoomSearchFavorites/', '');
        return { key: label, label, record: JSON.parse(favRecord.Value) };
      });
    });

    this.newFormData = this.ustService.formDataResponse.subscribe((formData) => {
      // * date field is exempted from user favorites

      // save favorites with input text
      if (this.favoriteLabel) {
        const favoriteLabel = this.generateFavoriteLabel(this.favoriteLabel);

        this.ustService.storeSearchTerms(favoriteLabel, formData).pipe(first()).subscribe(() => {

          this.favoriteSearchTerms.push({ key: favoriteLabel, label: favoriteLabel, record: formData });

          // post it and clear value
          this.favoriteLabel = '';
        });
      }
    });

  }

  generateFavoriteLabel(favoriteLabel) {
    if (!favoriteLabel) { throw new Error('favoriteLabel must be provided'); }

    if (this.favoriteSearchTerms.findIndex(rec => rec.key === favoriteLabel) === -1) { return favoriteLabel; }

    const seqdNumbers = this.favoriteSearchTerms
      .filter(rec => rec.key.startsWith(`${favoriteLabel} (`))
      .map(rec => Number(
        rec.key.replace(`${favoriteLabel} (`, '').replace(/\)$/, ''))
      )
      .filter(num => Number.isFinite(num))
      .sort();

    let nextSeq = 1;

    while (seqdNumbers.contains(nextSeq)) {
      ++nextSeq;
    }

    return `${favoriteLabel} (${nextSeq})`;
  }

  ngOnDestroy() {
    this.newFormData.unsubscribe();
    document.removeEventListener('click', this.globalUIEventHandler.bind(this));
    document.removeEventListener('focus', this.globalUIEventHandler.bind(this));
  }

  globalUIEventHandler(ev: MouseEvent | FocusEvent) {
    const targetWithinScope = this.wrapper.nativeElement.contains(ev.target);
    if (targetWithinScope || this.shouldExpand !== true) { return; }

    this.closeDropdown();
  }

  toggleDropdown() {
    this.shouldExpand = !this.shouldExpand;
  }

  closeDropdown() {
    this.shouldExpand = false;
  }

  saveSearchTerms() {
    this.searchTermsLabelPrompt.openModal();
  }

  applySearchTerms(key: string, record) {
    this.ustService.applyFormData.next(record);
    this.closeDropdown();
  }

  deleteSearchTerm(key: string) {
    this.ustService.discardSearchTerms(key).pipe(first()).subscribe(() => {
      const recNdx = this.favoriteSearchTerms.findIndex(fRec => fRec.label === key);
      if (recNdx > -1) {
        this.favoriteSearchTerms.splice(recNdx, 1);
      }
    }, err => {
      console.error('discard search terms error', err, key);
    });

  }

  onConfirmSave() {
    if (this.favoriteLabel) {
      this.ustService.formDataRequest.next();
    }
  }

}
